import React, {useState} from 'react';
import {IconButton, ListItemIcon, ListItemText, Menu, MenuItem} from "@mui/material";
import {DeleteForever, Edit, MoreHoriz} from "@mui/icons-material";
import {styled} from "@mui/material/styles";

const MenuFontColorSecondaryDarkDeleteForever = styled(DeleteForever)(({theme}) => ({
  color: theme.palette.secondary.dark
}));

const MenuFontColorSecondaryDarkEdit = styled(Edit)(({theme}) => ({
  color: theme.palette.secondary.dark
}));

const MenuMinWidthAuto = styled(ListItemIcon)(() => ({
  minWidth: 'auto'
}));

const MenuColumnGap8 = styled(MenuItem)(() => ({
  columnGap: '0.57rem',
}));

export type PaymentMethodMenuAction = 'remove' | 'rename';

interface PaymentMethodsActionsMenuProps {
  onSelect: (action: PaymentMethodMenuAction) => void;
  disableRemove?: boolean;
}

const PaymentMethodsActionsMenu = ({ onSelect, disableRemove = false }: PaymentMethodsActionsMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const menuOpen = Boolean(anchorEl);

  const onIconClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleSelect = (value: PaymentMethodMenuAction) => {
    handleCloseMenu();
    onSelect(value);
  };

  return (
    <>
      <IconButton
        onClick={onIconClick}
        aria-haspopup={true}
        aria-controls={'ss-payment-actions'}
      >
        <MoreHoriz />
      </IconButton>
      <Menu
        id={'ss-payment-actions'}
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleCloseMenu}
        keepMounted
      >
        {
          !disableRemove && <MenuColumnGap8 onClick={() => handleSelect('remove')}>
            <MenuMinWidthAuto>
              <MenuFontColorSecondaryDarkDeleteForever fontSize={'small'}/>
            </MenuMinWidthAuto>
            <ListItemText
              primary={'Remove'}
              primaryTypographyProps={{
                variant: 'subtitle2',
                color: 'secondary'
              }}
            />
          </MenuColumnGap8>
        }
        <MenuColumnGap8 onClick={() => handleSelect('rename')}>
          <MenuMinWidthAuto>
            <MenuFontColorSecondaryDarkEdit fontSize={'small'} />
          </MenuMinWidthAuto>
          <ListItemText
            primary={'Rename'}
            primaryTypographyProps={{
              variant: 'subtitle2',
              color: 'secondary'
            }}
          />
        </MenuColumnGap8>
      </Menu>
    </>
  );
};

export default PaymentMethodsActionsMenu;
